import React from 'react';
import { useUsers } from '../../hooks/useUsers';
import { UserCard } from '../user/UserCard';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { EmptyState } from '../common/EmptyState';

export const NetworkUsers = ({ network }) => {
  const { users, loading, error } = useUsers(network?.businessNetworkID);

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="alert alert-danger">Error loading users</div>;
  if (!users || users.length === 0) return <EmptyState message="No users in this network yet" />;

  return (
    <div className="p-4">
      <h5 className="mb-4">Network Users ({users.length})</h5>
      <div className="row g-3">
        {users.map((user) => (
          <div key={user.createdByWalletUserRegistrationID} className="col-12">
            <UserCard user={user} network={network} />
          </div>
        ))}
      </div>
    </div>
  );
};
